import type { FaireProductEntity } from "../../entity_types/product";

export const p_vhvdx5qjqz: FaireProductEntity = {
  token: "p_vhvdx5qjqz",
  type: "product",
  name: "Super Pooper",
  brandToken: "b_2hx23125l5",
  brandName: "Nurished",
  imageUrl:
    "https://cdn.faire.com/fastly/187b9088335ce4f1247fca67231021987f3ea1dc2ce47f0273820d5b1a0974cc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e06344ed287f548ae2bf4a27b24c83a5ef954a110dc37c46a6dcd59e8b44858b.png",
    "https://cdn.faire.com/fastly/61444885ae2900f2f9c37dc91b1a00b487ff6057b005494d66e9dc30078d4b58.png",
    "https://cdn.faire.com/fastly/6b6ea15bfeb4d90910f0b64d569cb575e65403eace0b4f163ce31b4d1c2afdcd.png",
    "https://cdn.faire.com/fastly/8b2c122ec77c026090e58b62f08e1c680523f0dfb96eed41d4a4d6c219e49841.png",
  ],
  priceDollars: 10,
  description:
    "Some kids just have a tough time 💩. As parents, we know the pain of tummy aches & constipation. Super Pooper is a clean and effective way to help your kids stay regular & feel better. Made from just 3 ingredients - it's tasteless, odorless, and effective! Simply add a scoop to your favorite flavor of Mighty Milk each day for a healthier, happier gut.\n",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:50.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
